import { render, staticRenderFns } from "./cardProp.vue?vue&type=template&id=21970aa0&scoped=true&"
import script from "./cardProp.vue?vue&type=script&lang=js&"
export * from "./cardProp.vue?vue&type=script&lang=js&"
import style0 from "./cardProp.vue?vue&type=style&index=0&id=21970aa0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21970aa0",
  null
  
)

export default component.exports